import { getEventsWithDetails } from 'api/event'
import { useEffect, useState } from 'react'
import { EventDetails } from 'types/Event'

export const useEventDetailsForScan = () => {
    const [eventDetails, setEventDetails] = useState<EventDetails[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getEventsWithDetails()
                setEventDetails(data)
            } catch (err) {
                setError(err instanceof Error ? err : new Error('Unknown error'))
            } finally {
                setIsLoading(false)
            }
        }

        fetchData()
    }, [])

    return { eventDetails, isLoading, error }
}
